import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import LockFingerprint from 'src/assets/img/LockFingerprint.png'
import LockX from 'src/assets/img/LockX.png'

import Login from 'src/ui/templates/Login'
import WrappedInput from 'src/ui/atoms/Input/Wrapped'
import Button from 'src/ui/atoms/Button'
import useResetPasswordApi from './useResetPasswordApi'

const ForgotPassword = () => {
  const navigate = useNavigate()
  const [resetState, setResetState] = useState('pending')
  const [leftContent, setLeftContent] = useState(LockFingerprint)
  const { resetPassword } = useResetPasswordApi()

  const queryParams = new URLSearchParams(location.search)
  const email = queryParams.get('email')
  const recoveryCode = queryParams.get('code')

  const {
    register,
    watch,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  })

  const handleResetPassword = async ({ password }: { password: string }) => {
    try {
      await resetPassword({
        email,
        recoveryCode,
        newPassword: password,
      })
      setResetState('success')
    } catch (error) {
      console.error(error)
      setResetState('failure')
      setLeftContent(LockX)
    }
  }

  return (
    <Login leftContent={leftContent}>
      {resetState === 'pending' && (
        <div className="flex h-full flex-col justify-between gap-6">
          <h1 className="text-center text-white">Reset your password</h1>
          <form
            className="grid gap-6"
            onSubmit={handleSubmit((data) => handleResetPassword(data as { password: string }))}>
            <div className="grid gap-4">
              <WrappedInput
                placeholder="AwesomePassword123!"
                label="Password"
                error={errors.password}
                labelPosition="inside"
                type="password"
                eye
                {...register('password', {
                  required: 'Required field.',
                  pattern: {
                    value: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                    message:
                      'Password must contain at least 8 characters, uppercase letter and a symbol',
                  },
                })}
              />
              <WrappedInput
                placeholder="AwesomePassword123!"
                label="Confirm Password"
                error={errors.confirmPassword}
                labelPosition="inside"
                type="password"
                eye
                {...register('confirmPassword', {
                  required: 'Required field.',
                  pattern: {
                    value: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                    message:
                      'Password must contain at least 8 characters, uppercase letter and a symbol',
                  },
                  validate: (val: string) => {
                    if (watch('password') != val) {
                      return 'Password does not match'
                    }
                  },
                })}
              />
            </div>
            <Button name="Change password" disabled={!isValid} />
          </form>
          <span className="text-white">
            By sending link you agree to the{' '}
            <a
              className="text-main-blue"
              target="_blank"
              href="//zoidcore.com/terms-and-conditions.html"
              rel="noreferrer">
              Terms of use
            </a>{' '}
            and{' '}
            <a
              className="text-main-blue"
              target="_blank"
              href="//zoidcore.com/privacy-policy.html"
              rel="noreferrer">
              Privacy Policy
            </a>
          </span>
        </div>
      )}

      {resetState === 'success' && (
        <div className="grid h-full content-center gap-6 text-center">
          <h1 className="text-white ">Password changed successfully!</h1>
          <p className="text-lg text-white">
            You’re almost ready to start enjoying ZoidCore again. Just login again with your new
            password.
          </p>
          <Button name="Login" onClick={() => navigate('/login')} />
        </div>
      )}

      {resetState === 'failure' && (
        <div className="grid h-full content-center gap-6 text-center">
          <h1 className="text-white ">An error has occurred.</h1>
          <p className="text-lg text-white">
            It seems that your password could not be changed at the moment. Please try again and
            ensure that you have entered the correct
          </p>
          <Button name="Retry" onClick={() => navigate('/forgot-password')} />
        </div>
      )}
    </Login>
  )
}

export default ForgotPassword
